export const KEYS = {
  FORM_IDS: 'formIds',
  FORMS: 'forms'
}

export default class FormManager {
  static getFormIds () {
    let formIds = {};
    try {
      const data = localStorage.getItem(KEYS.FORM_IDS);
      if (data) {
        formIds = JSON.parse(data) || {};
      }
    } catch (err) {}
    return formIds;
  }

  static getForms () {
    let forms = {};
    try {
      const data = localStorage.getItem(KEYS.FORMS);
      if (data) {
        forms = JSON.parse(data) || {};
      }
    } catch (err) {}
    return forms;
  }

  static getFormId (userId) {
    return FormManager.getFormIds()[userId];
  }

  static getForm (formId) {
    return FormManager.getForms()[formId];
  }

  static setFormId (userId, formId) {
    if (!userId || !formId) return;
    const formIds = FormManager.getFormIds();
    formIds[userId] = formId;
    localStorage.setItem(KEYS.FORM_IDS, JSON.stringify(formIds));
  }

  static setForm (formId, params = {}) {
    if (!formId) return;
    const forms = FormManager.getForms();
    forms[formId] = params;
    localStorage.setItem(KEYS.FORMS, JSON.stringify(forms));
  }

  static delFormId (userId) {
    const formIds = FormManager.getFormIds();
    const formId = formIds[userId];
    delete formIds[userId];
    localStorage.setItem(KEYS.FORM_IDS, JSON.stringify(formIds));
    return formId;
  }

  static delForm (formId) {
    const forms = FormManager.getForms();
    const params = forms[formId];
    delete forms[formId];
    localStorage.setItem(KEYS.FORM_IDS, JSON.stringify(forms));
    return params;
  }

  static delFormData (userId) {
    const id = FormManager.delFormId(userId);
    return {
      ...FormManager.delForm(id),
      id,
    };
  }
}